import { Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FileUploadStatus } from '../../uploader.interface';

@Component({
  selector: 'glxy-image-upload-tile',
  templateUrl: './image-upload-tile.component.html',
  styleUrls: ['./image-upload-tile.component.scss'],
})
export class GalaxyImageUploadTileComponent implements OnChanges, OnInit {
  @HostBinding('class') class = 'glxy-image-upload-tile';

  /** Source image file for rendering to the tile. If missing, will not show edit or delete buttons */
  @Input() file?: File | Blob;

  @Input() url?: string;

  /** Current upload status of the image */
  @Input() status?: FileUploadStatus | null;

  /** If true, will display the delete button in the tile */
  @Input() showDeleteButton?: boolean;

  /** If true, will display the edit button in the tile */
  @Input() showEditButton?: boolean;

  @Input() noViewFileStatus = false;

  /** Emits when this tile's edit button has been clicked */
  @Output() edit: EventEmitter<void> = new EventEmitter();

  /** Emits when this tile's delete button has been clicked */
  @Output() delete: EventEmitter<void> = new EventEmitter();

  _url?: SafeUrl;
  FileUploadStatus = FileUploadStatus;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    if (this.noViewFileStatus) {
      this.status = null;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Disregard url updates if we have a local file to read from
    if (!this.file && changes.url && changes.url.currentValue !== changes.url.previousValue) {
      this._url = this.sanitizer.bypassSecurityTrustUrl(changes.url.currentValue);
    }

    if (changes.file && changes.file.currentValue !== changes.file.previousValue) {
      this._url = this.convertFileToUrl(changes.file.currentValue);
    }
  }

  /**
   * Converts an image file to a safe URL to be rendered into an image tag
   * @param file - The file to be rendered in the image tile
   */
  convertFileToUrl(file: File | Blob): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
  }

  /**
   * Triggered when the edit button has been clicked for this tile
   */
  editClick(): void {
    this.edit.emit();
  }

  /**
   * Triggered when the delete button has been clicked for this tile
   */
  deleteClick(): void {
    this.delete.emit();
  }
}
